/**
 * Server-rendered "Pick X if..." decision block for /compare/[slug] pages.
 * Liquid-glass styling lives in compare-glass.css (`.cmp-pick--a/--b`).
 * A = green, B = amber, with an A/B badge in the heading.
 */

import type { ReactNode } from 'react'
import { CheckCircle2 } from 'lucide-react'

interface DecisionBlockProps {
  headline: string
  reasons: string[]
  variant?: 'a' | 'b'
  /** Optional action chips (calculator / cost-estimator links) rendered in a row. */
  actions?: ReactNode
}

export function DecisionBlock({ headline, reasons, variant = 'a', actions }: DecisionBlockProps) {
  return (
    <div className={`cmp-pick cmp-pick--${variant}`}>
      <h3 className="cmp-pick__h">
        <span className="badge">{variant.toUpperCase()}</span>
        {headline}
      </h3>
      <ul>
        {reasons.map((reason) => (
          <li key={reason}>
            <CheckCircle2 size={17} aria-hidden="true" />
            <span>{reason}</span>
          </li>
        ))}
      </ul>
      {actions && <div className="cmp-pick__actions">{actions}</div>}
    </div>
  )
}
